<div class="details-container" *ngIf="!loading; else loadingTpl">

  <!-- Client details card -->
  <mat-card class="client-card">
    <mat-card-header>
      <mat-card-title>Client Info</mat-card-title>
      <mat-card-subtitle>Pool Point: {{ pool.pool_point_name }}</mat-card-subtitle>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content style="overflow-y:auto; min-height:0">
      <!-- Client selector -->
      <mat-form-field appearance="fill" class="client-selector">
        <mat-label>Select Client</mat-label>
        <mat-select [(value)]="selectedClient" (selectionChange)="selectClient($event.value)">
          <mat-option *ngFor="let client of clients" [value]="client">
            {{ client.pool_point_client_name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Contact info -->
      <div *ngIf="selectedClientContact; else noClientContact" class="client-info">
        <p><strong>Organization:</strong> {{ selectedClientContact.contact_organization }}</p>
        <p><strong>Email:</strong> {{ selectedClientContact.contact_email || '—' }}</p>
        <p><strong>Phone:</strong>
          {{ selectedClientContact.contact_phones?.[0]?.phone_number || '—' }}
        </p>
        <p><strong>Address:</strong>
          {{ selectedClientContact.contact_addresses?.[0]?.address_street }},
          {{ selectedClientContact.contact_addresses?.[0]?.address_locality }},
          {{ selectedClientContact.contact_addresses?.[0]?.address_region }}
        </p>
      </div>

      <ng-template #noClientContact>
        <p><em>No contact info available for this client</em></p>
      </ng-template>
    </mat-card-content>
    <mat-card-actions>
      <button mat-button color="warn" (click)="deleteClient()">Delete Selected Client</button>
      <!-- <button mat-button color="primary" (click)="addClient()">Add Client</button> -->
      <!-- <button mat-button color="primary" (click)="addScope()">Add Scope</button> -->
    </mat-card-actions>
  </mat-card>

  <!-- Stores grid -->
  <mat-card class="stores-card">
    <mat-card-header>
      <mat-card-title>Serviced Stores</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>
    <mat-card-content>
      <div class="table-container">
        <table mat-table [dataSource]="stores" class="mat-elevation-z1 full-width-table">

          <!-- Store Number -->
          <ng-container matColumnDef="number">
            <th mat-header-cell *matHeaderCellDef> Store # </th>
            <td mat-cell *matCellDef="let store"> {{ store.pool_point_store_number }} </td>
          </ng-container>

          <!-- Organization -->
          <ng-container matColumnDef="organization">
            <th mat-header-cell *matHeaderCellDef> Organization </th>
            <td mat-cell *matCellDef="let store"> {{ store.contact_organization }} </td>
          </ng-container>

          <!-- City -->
          <ng-container matColumnDef="city">
            <th mat-header-cell *matHeaderCellDef> City </th>
            <td mat-cell *matCellDef="let store"> {{ store.address_locality }} </td>
          </ng-container>

          <!-- Province -->
          <ng-container matColumnDef="province">
            <th mat-header-cell *matHeaderCellDef> Prov </th>
            <td mat-cell *matCellDef="let store"> {{ store.address_region }} </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions </th>
            <td mat-cell *matCellDef="let store">
              <button mat-button color="primary" (click)="editStoreContactInfo(store.pool_point_store_contact_uuid)">Edit Contact Info</button>
              <button mat-button color="primary">Change Pool Point</button>
              <button mat-button color="warn" (click)="deleteStore(store)">Delete</button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['number','organization','city','province','actions']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['number','organization','city','province','actions'];"></tr>
        </table>
      </div>
      <button mat-button color="primary" (click)="addStore()">Add Store</button>

    </mat-card-content>
  </mat-card>

</div>

<ng-template #loadingTpl>
  <div class="loading">Loading…</div>
</ng-template>
